import { endPoints } from "@/constants";
import * as apiService from "./apiService";

const adaptPhotos = (photos) =>
  (photos || []).map((p) => ({
    image: p?.MediaURL,
    IsValid: p?.MediaURL ? 1 : 0,
    MediaKey: p?.MediaKey,
    DisplayOrder: p?.DisplayOrder,
    LongDescription: p?.LongDescription,
  }));

export async function getMlsListingByKey(listingKey) {
  const response = await apiService.apiCall(
    endPoints.GET_MLS_LISTING_BY_KEY + encodeURIComponent(listingKey),
    "GET",
  );
  const listing = response?.data || response?.result || null;
  if (listing?.media) {
    listing.media = {
      photos: adaptPhotos(listing.media.photos),
      videos: listing.media.videos || [],
      documents: listing.media.documents || [],
    };
  }
  return { ...response, data: listing };
}

export async function getMyMlsListings(query) {
  return await apiService.apiCall(
    endPoints.GET_MY_MLS_LISTINGS,
    "GET",
    query,
  );
}

export async function matchMlsListingByAddress(params) {
  return await apiService.apiCall(
    endPoints.MATCH_MLS_LISTING_BY_ADDRESS,
    "GET",
    params,
  );
}
